import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { useRepositoryQuery, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { FormCheckboxField, LocalizedPercent } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useGetAccountingSurchargeFeeSuspense } from '../../../../queries';
import { ServiceName } from '../../../../../../components/commander-ui/ServiceName';
import { TokenizeCardFormField } from '../TokenizeCardForm/schema';
import { GatewayPaymentFormField, GatewayPaymentFormValues } from './schema';

export const SurchargeFeeCheckbox = ({ accountId }: { accountId: string }) => {
    const { watch, setValue } = useFormContext<GatewayPaymentFormValues>();
    const enterpriseId = useCurrentEnterpriseId();
    const paymentCardId = watch(GatewayPaymentFormField.PaymentMethodId);
    const newPaymentCardNumber = watch(TokenizeCardFormField.PaymentCardNumber);

    const {
        data: { surchargeFees, surchargeServiceId },
    } = useGetAccountingSurchargeFeeSuspense();

    const { data: surchargeService } = useRepositorySuspenseQuery(
        'services',
        'getAll',
        { serviceIds: surchargeServiceId ? [surchargeServiceId] : null, enterpriseIds: [enterpriseId] },
        { select: (data) => (data.services?.[0].id === surchargeServiceId ? data.services[0] : null) }
    );

    const { data: paymentCard } = useRepositoryQuery(
        'accountPaymentMethods',
        'getAll',
        { accountId, onlyGateway: true, onlyChargeable: true },
        { select: (data) => data.paymentCards?.find((card) => card.id === paymentCardId) }
    );

    const paymentCardType = paymentCard?.type || newPaymentCardNumber?.type || '';
    const surchargeFee = surchargeFees[paymentCardType];

    useEffect(() => {
        const surchargingEnabled = !!(surchargeService && surchargeFee);
        setValue(GatewayPaymentFormField.ApplyPaymentCardSurcharge, surchargingEnabled);

        return () => setValue(GatewayPaymentFormField.ApplyPaymentCardSurcharge, false);
    }, [setValue, surchargeFee, surchargeService]);

    if (!surchargeService || !surchargeFee) {
        return null;
    }

    return (
        <FormCheckboxField name={GatewayPaymentFormField.ApplyPaymentCardSurcharge}>
            <ServiceName service={surchargeService} />
            {UnicodeEntity.NoBreakSpace}
            <LocalizedPercent percent={surchargeFee} />
        </FormCheckboxField>
    );
};
